import { BOOKING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "../../useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

type SendClinicLocationAPIResponse = { status: boolean; message: string };

export const useSendClinicLocationWhatsappAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (clinicId: string, mobile_number: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: SendClinicLocationAPIResponse = await axios
          .post(
            `${BOOKING_APIS?.CLINIC_LOCATION_WHATSAPP_SEND?.baseURL}`,
            {
              clinic_id: clinicId,
              send_to: mobile_number,
            },
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true && res.data) {
              toast.success("Clinic location sent successfully via WhatsApp");
              return { status: true, message: "sent" };
            } else {
              toast.error("Failed to send clinic location");
              return { status: false, message: "failed" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e?.config?.["curlCommand"]);
            captureError(e);
            toast.error("Failed to send clinic location");
            return { status: false, message: "failed" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false, message: "error" };
      }
    },
    [dispatch, sendCurl, captureError],
  );

  return { execute };
};
